import React from 'react';
import { Button } from './ui/button';
import { AlarmClock, CalendarClock } from 'lucide-react';

const ACTIVE_STATUSES = ['PENDING', 'CONFIRMED'];

function fmtWhen(dt) {
  return dt.toLocaleString(undefined, { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

// Banner reminders for bookings starting within the next 48h (urgent style <=24h).
export default function BookingReminderBanner({ bookings, role = 'client', onView }) {
  const now = Date.now();
  const soon = (bookings || [])
    .filter((b) => b && b.startDateTime && ACTIVE_STATUSES.includes(b.status))
    .map((b) => {
      const start = new Date(b.startDateTime);
      return { b, start, hours: (start.getTime() - now) / 36e5 };
    })
    .filter((x) => x.hours > 0 && x.hours <= 48)
    .sort((a, z) => a.hours - z.hours)
    .slice(0, 3);

  if (soon.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="booking-reminders">
      {soon.map(({ b, start, hours }) => {
        const urgent = hours <= 24;
        const who = role === 'provider' ? (b.clientName || 'a client') : (b.providerName || b.provider?.name || 'your provider');
        const inText = hours < 1.5 ? 'in about an hour' : `in ${Math.round(hours)} hours`;
        return (
          <div
            key={b.id}
            className={`rounded-md border p-3 text-sm flex flex-wrap items-center gap-2 ${
              urgent ? 'border-amber-300 bg-amber-50 text-amber-900' : 'border-sky-300 bg-sky-50 text-sky-900'
            }`}
            data-testid={urgent ? `reminder-24h-${b.id}` : `reminder-48h-${b.id}`}
          >
            {urgent ? <AlarmClock className="h-4 w-4 shrink-0" /> : <CalendarClock className="h-4 w-4 shrink-0" />}
            <span className="flex-1 min-w-[200px]">
              <strong>{urgent ? 'Reminder: appointment ' : 'Coming up: appointment '}{inText}</strong>
              {' — '}{b.serviceName || 'Service'} with {who}, {fmtWhen(start)}
            </span>
            {onView && (
              <Button size="sm" variant="outline" onClick={() => onView(b)} data-testid={`reminder-view-${b.id}`}>
                View
              </Button>
            )}
          </div>
        );
      })}
    </div>
  );
}
